import React from 'react';
import { Button, IconButton } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import { IconButtonProps } from '@mui/material/IconButton';
import { Link, LinkProps as RouterLinkProps } from 'react-router-dom';

type RouterLinkExtras = Pick<RouterLinkProps, 'to' | 'replace' | 'state'>;

type LinkButtonProps = Omit<ButtonProps<'a'>, 'component' | 'href'> & RouterLinkExtras;

export const LinkButton = React.forwardRef<HTMLAnchorElement, LinkButtonProps>(
  ({ children, to, replace, state, ...rest }, ref) => (
    <Button
      component={Link}
      to={to}
      replace={replace}
      state={state}
      {...rest}
      ref={ref}
    >
      {children}
    </Button>
  )
);

type LinkIconButtonProps = Omit<IconButtonProps<'a'>, 'component' | 'href'> &
  RouterLinkExtras;

export const LinkIconButton = React.forwardRef<
  HTMLAnchorElement,
  LinkIconButtonProps
>(({ children, to, replace, state, ...rest }, ref) => (
  <IconButton
    component={Link}
    to={to}
    replace={replace}
    state={state}
    {...rest}
    ref={ref}
    size="large"
  >
    {children}
  </IconButton>
));
